import { render, staticRenderFns } from "./myAwards.vue?vue&type=template&id=263effb4&scoped=true"
import script from "./myAwards.vue?vue&type=script&lang=js"
export * from "./myAwards.vue?vue&type=script&lang=js"
import style0 from "./myAwards.vue?vue&type=style&index=0&id=263effb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263effb4",
  null
  
)

export default component.exports